import React, { useEffect, useState } from "react";
import { ApproveButton, RejectButton } from "../../mui/Buttons/Buttons";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import {
  eveningFoodApproveOrRejectOrBulk,
  getEveningFoodList,
} from "../../../redux/features/foodSlice";

const ApprovalOrRejectForAllUsers = ({ row }) => {
  const { loading } = useSelector((store) => store.food);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const handleAction = (status) => {
    const data = { id: row.food_id, status: status };
    dispatch(eveningFoodApproveOrRejectOrBulk(data)).then((res) => {
      if (res.payload.status == "failed" || res.payload.status == "error") {
        enqueueSnackbar(`${res.payload.message}`, { variant: "error" });
      } else {
        dispatch(getEveningFoodList({ date: row.food_date }));
        enqueueSnackbar(`${res.payload.message}`, { variant: "success" });
      }
    });
  };

  return (
    <Box>
      {row.food_approval_status == 0 && (
        <>
          <ApproveButton disabled={loading} action={() => handleAction(1)}>
            Approve
          </ApproveButton>
          <RejectButton
            disabled={loading}
            action={() => handleAction(2)}
            sx={{ ml: 2 }}
          >
            Reject
          </RejectButton>
        </>
      )}
      {row.food_approval_status == 1 && (
        <RejectButton
          disabled={loading}
          action={() => handleAction(2)}
          sx={{ ml: 2 }}
        >
          Reject
        </RejectButton>
      )}
      {row.food_approval_status == 2 && (
        <ApproveButton disabled={loading} action={() => handleAction(1)}>
          Approve
        </ApproveButton>
      )}
    </Box>
  );
};

export default ApprovalOrRejectForAllUsers;
